<template>
  <a :href="buttonLink" v-if="buttonLink" class="seu-button" :target="target" :class="{'isLarge':isLarge, 'isSmall':isSmall, 'isTiny':isTiny}">
    <span v-if="buttonIconBefore" class="icon-container before">
      <img :src="buttonIconBefore" alt="">
    </span>
    <span class="button-label caps-medium">{{ label }}</span>
    <span v-if="buttonIconAfter" class="icon-container after">
      <img :src="buttonIconAfter" alt="">
    </span>

  </a>
  <router-link :to="route" v-else-if="route" class="seu-button" :target="target" :class="{'isLarge':isLarge, 'isSmall':isSmall, 'isTiny':isTiny}">
    <span v-if="buttonIconBefore" class="icon-container before">
      <img :src="buttonIconBefore" alt="">
    </span>
    <span class="button-label caps-medium">{{ label }}</span>
    <span v-if="buttonIconAfter" class="icon-container after">
      <img :src="buttonIconAfter" alt="">
    </span>

  </router-link>
  <button v-else @click="$ev => $emit('click', $ev)" class="seu-button"
          :class="{'isLarge':isLarge, 'isSmall':isSmall, 'isTiny':isTiny}">
    <span v-if="buttonIconBefore" class="icon-container before">
      <img :src="buttonIconBefore" alt="">
    </span>
    <span class="button-label caps-medium">{{ label }}</span>
    <span v-if="buttonIconAfter" class="icon-container after">
      <img :src="buttonIconAfter" alt="">
    </span>
  </button>

</template>

<script>
export default {
  name: "SeuButton",
  props: {
    label: {
      type: String,
      required: true,
    },
    buttonLink: {
      type: String
    },
    target: {
      type: String,
      default: '_self'
    },
    route: Object,
    buttonIconBefore: String,
    buttonIconAfter: String,
    isLarge: Boolean,
    isSmall: Boolean,
    isTiny: Boolean,
  }

}
</script>

<style lang="scss">
@import "SeuButton";
</style>
